import {isWidgetContext, useAuthStore} from '~/stores/auth'
import {adoptSharedCookie} from '~/composables/adoptSharedCookie'

function isTokenWidget() {
    if (import.meta.client) {
        return isWidgetContext()
    }

    const path = useRequestURL().pathname

    return path.startsWith('/widget') && !path.startsWith('/widget/doctor/')
}

// Витрина и основной сайт делят cookie, но не localStorage. Публичные страницы
// вроде онлайн-консультации не проходят auth-middleware, поэтому сессию читаем здесь.
export default defineNuxtPlugin(async () => {
    if (isTokenWidget()) {
        return
    }

    const store = useAuthStore()
    if (import.meta.client) {
        store.restoreSession()
    }
    if (store.isAuth) {
        return
    }

    const absent = useState('sharedSessionAbsent', () => false)
    if (absent.value) {
        return
    }

    if (import.meta.server) {
        const cookie = useRequestHeaders(['cookie']).cookie ?? ''
        if (!cookie.includes('access_token=')) {
            absent.value = true
            return
        }
    }

    await adoptSharedCookie(store)
})
